/* ==============================
   CWC Blog
   ------------------------------
   The "Browse all topics" menu is a <details> disclosure, so it opens without
   script. This adds what a plain disclosure lacks:
   - a search box that narrows the list of topics,
   - arrow keys from the search box through the list,
   - Escape and a click outside to close it,
   - keeping the panel on screen when the menu ends the row on the right.
   ============================== */
(function () {
  'use strict';

  function setup(menu) {
    if (menu.getAttribute('data-cwc-ready')) return;
    menu.setAttribute('data-cwc-ready', '1');
    menu.classList.add('cwc_blog__menu--js');

    var toggle = menu.querySelector('summary');
    var panel = menu.querySelector('.cwc_blog__menu-panel');
    var input = menu.querySelector('[data-cwc-topic-search]');
    var list = menu.querySelector('[data-cwc-topic-list]');
    var empty = menu.querySelector('[data-cwc-topic-empty]');
    var items = Array.prototype.slice.call(list.querySelectorAll('li'));

    function visibleLinks() {
      return items
        .filter(function (item) {
          return !item.hidden;
        })
        .map(function (item) {
          return item.querySelector('a');
        });
    }

    function filter() {
      var query = (input.value || '').trim().toLowerCase();
      var shown = 0;
      items.forEach(function (item) {
        var match = query === '' || item.textContent.toLowerCase().indexOf(query) !== -1;
        item.hidden = !match;
        if (match) shown++;
      });
      if (empty) empty.hidden = shown > 0;
    }

    menu.addEventListener('toggle', function () {
      if (!menu.open) return;

      menu.classList.remove('cwc_blog__menu--right');
      if (panel.getBoundingClientRect().right > window.innerWidth - 16) {
        menu.classList.add('cwc_blog__menu--right');
      }

      input.value = '';
      filter();
      // On a phone the keyboard would cover the list, so the box waits for a tap there
      if (window.matchMedia('(pointer: fine)').matches) input.focus();

      var active = list.querySelector('.cwc_blog__menu-item--active');
      if (active) active.scrollIntoView({block: 'nearest'});
    });

    input.addEventListener('input', filter);

    input.addEventListener('keydown', function (event) {
      var first = visibleLinks()[0];
      if (!first) return;
      if (event.key === 'Enter') {
        event.preventDefault();
        first.click();
      } else if (event.key === 'ArrowDown') {
        event.preventDefault();
        first.focus();
      }
    });

    list.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      var links = visibleLinks();
      var index = links.indexOf(document.activeElement);
      if (index === -1) return;
      event.preventDefault();
      var target = event.key === 'ArrowDown' ? links[index + 1] : links[index - 1];
      if (target) {
        target.focus();
      } else if (event.key === 'ArrowUp') {
        input.focus();
      }
    });

    menu.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menu.open) {
        menu.open = false;
        toggle.focus();
      }
    });

    document.addEventListener('click', function (event) {
      if (menu.open && !menu.contains(event.target)) menu.open = false;
    });
  }

  function run() {
    document.querySelectorAll('[data-cwc-topic-menu]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Theme editor re-renders the section without a page load
  document.addEventListener('shopify:section:load', run);
})();
